var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('navbar'),_vm._v(" "),_c('div',{class:_vm.containerClass},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }